import { z } from 'zod';
import { RoleCode } from './auth.js';

export const CreateUserInput = z.object({
  email: z.string().email(),
  password: z.string().min(8).max(256),
  displayName: z.string().min(1).max(120),
  telegramUsername: z.string().regex(/^@[A-Za-z0-9_]{3,}$/).nullish(),
  roles: z.array(RoleCode).min(1),
});
export type CreateUserInput = z.infer<typeof CreateUserInput>;

export const UpdateUserInput = z.object({
  displayName: z.string().min(1).max(120).optional(),
  telegramUsername: z.string().regex(/^@[A-Za-z0-9_]{3,}$/).nullish(),
  isActive: z.boolean().optional(),
  roles: z.array(RoleCode).min(1).optional(),
  password: z.string().min(8).max(256).optional(),
});
export type UpdateUserInput = z.infer<typeof UpdateUserInput>;
